import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import "./treatmentTabs.scss";

const TreatmentTabs = ({ tabs, activeTab, onTabClick }) => {
  const { t } = useTranslation();
  return (
    <div className="treatments__tabs" role="tablist" aria-label={t("treatments.tabs.ariaLabel", "Categorieën behandelingen")}> 
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          role="tab"
          id={`treatments-tab-${tab.id}`}
          aria-selected={activeTab === tab.id}
          aria-controls={`treatments-panel-${tab.id}`}
          className={
            "treatments__tab" + (activeTab === tab.id ? " treatments__tab--active" : "")
          }
          onClick={() => {
            if (activeTab !== tab.id) {
              onTabClick(tab.id);
            }
          }}
          tabIndex={activeTab === tab.id ? 0 : undefined}
          disabled={activeTab === tab.id}
        >
          {t(tab.i18nKey, tab.defaultLabel)}
        </button>
      ))}
    </div>
  );
};

TreatmentTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      i18nKey: PropTypes.string.isRequired,
      defaultLabel: PropTypes.string.isRequired,
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired,
};

export default TreatmentTabs;
